export { default } from './SkeletonFareListTwoColumnsMobile';
